var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-descriptions',{attrs:{"column":1}},[_vm._l((_vm.failureMsgList),function(item,index){return [_c('a-descriptions-item',{key:index,attrs:{"label":_vm.getLabel(item)}},[_vm._v(" "+_vm._s(_vm.getText(item))+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }